module.exports = __webpack_public_path__ + "static/media/physical_therapy.f9df77af.svg";